import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "preset",
    "endDate",
    "arr",
    "users",
    "newRange",
    "newArr",
    "newUsers"
  ]

  static values = {
    latestStart: String,
    latestEnd: String,
    renewalStart: String,
    currentArr: Number,
    currentUsers: Number
  }

  connect() {
    this.update()
  }

  selectPreset(event) {
    const years = event.currentTarget.dataset.years

    this.presetTargets.forEach((preset) => {
      preset.classList.toggle("active", preset === event.currentTarget)
    })

    if (years === "custom") {
      this.endDateTarget.readOnly = false
      this.endDateTarget.focus()
    } else {
      this.endDateTarget.readOnly = true
      this.endDateTarget.value = this.endDateForYears(Number.parseInt(years, 10))
    }

    this.update()
  }

  customDateChanged() {
    this.selectCustomPreset()
    this.update()
  }

  update() {
    const endsOn = this.endDateTarget.value
    const arr = this.numberValue(this.arrTarget.value)
    const users = this.numberValue(this.usersTarget.value)

    this.newRangeTarget.textContent = `${this.renewalStartValue} → ${endsOn || "..."}`
    this.newArrTarget.textContent = `€ ${this.formatNumber(arr)}`
    this.newUsersTarget.textContent = `${this.formatNumber(users)} users`

    this.newArrTarget.classList.toggle("changed", arr !== this.currentArrValue)
    this.newUsersTarget.classList.toggle("changed", users !== this.currentUsersValue)
  }

  selectCustomPreset() {
    this.presetTargets.forEach((preset) => {
      const active = preset.dataset.years === "custom"
      preset.classList.toggle("active", active)
      if (active) this.endDateTarget.readOnly = false
    })
  }

  endDateForYears(years) {
    const [year, month, day] = this.renewalStartValue.split("-").map((part) => Number.parseInt(part, 10))
    const targetYear = year + years
    const lastDayOfTargetMonth = new Date(Date.UTC(targetYear, month, 0)).getUTCDate()
    const date = new Date(Date.UTC(targetYear, month - 1, Math.min(day, lastDayOfTargetMonth)))
    date.setUTCDate(date.getUTCDate() - 1)

    return date.toISOString().slice(0, 10)
  }

  numberValue(value) {
    if (value === "") return 0

    return Number.parseInt(value, 10) || 0
  }

  formatNumber(value) {
    return new Intl.NumberFormat("nl-NL").format(value)
  }
}
